"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformNotificationTypeEnumToJSON = exports.transformJSONToNotificationTypeEnum = exports.NotificationTypeEnum = void 0;

/* tslint:disable */

/* eslint-disable */

/**
 * Zeplin API
 * Access your resources in Zeplin
 *
 * Contact: support@zeplin.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var transformNotificationTypeEnumToJSON = function transformNotificationTypeEnumToJSON(value) {
  return value;
};

exports.transformNotificationTypeEnumToJSON = transformNotificationTypeEnumToJSON;

var transformJSONToNotificationTypeEnum = function transformJSONToNotificationTypeEnum(value) {
  return value;
};
/**
 * 
 * @export
 * @enum {string}
 */


exports.transformJSONToNotificationTypeEnum = transformJSONToNotificationTypeEnum;
var NotificationTypeEnum;
exports.NotificationTypeEnum = NotificationTypeEnum;

(function (NotificationTypeEnum) {
  NotificationTypeEnum["WORKSPACE_PROJECT"] = "workspace.project";
  NotificationTypeEnum["WORKSPACE_STYLEGUIDE"] = "workspace.styleguide";
  NotificationTypeEnum["PROJECT_EXTENSION"] = "project.extension";
  NotificationTypeEnum["STYLEGUIDE_EXTENSION"] = "styleguide.extension";
  NotificationTypeEnum["USER_PROJECT_MEMBERSHIP"] = "user.project_membership";
  NotificationTypeEnum["USER_STYLEGUIDE_MEMBERSHIP"] = "user.styleguide_membership";
  NotificationTypeEnum["PROJECT_COMPONENT"] = "project.component";
  NotificationTypeEnum["STYLEGUIDE_COMPONENT"] = "styleguide.component";
  NotificationTypeEnum["PROJECT_COLOR"] = "project.color";
  NotificationTypeEnum["STYLEGUIDE_COLOR"] = "styleguide.color";
  NotificationTypeEnum["PROJECT_SCREEN_NOTE"] = "project.screen.note";
  NotificationTypeEnum["PROJECT_SCREEN_NOTE_COMMENT"] = "project.screen.note.comment";
  NotificationTypeEnum["PROJECT_SCREEN"] = "project.screen";
  NotificationTypeEnum["PROJECT_TEXT_STYLE"] = "project.text_style";
  NotificationTypeEnum["STYLEGUIDE_TEXT_STYLE"] = "styleguide.text_style";
  NotificationTypeEnum["PROJECT_SPACING_TOKEN"] = "project.spacing_token";
  NotificationTypeEnum["STYLEGUIDE_SPACING_TOKEN"] = "styleguide.spacing_token";
  NotificationTypeEnum["PROJECT_JIRA_ATTACHMENT"] = "project.jira_attachment";
  NotificationTypeEnum["PROJECT_SCREEN_SECTION_JIRA_ATTACHMENT"] = "project.screen_section.jira_attachment";
  NotificationTypeEnum["PROJECT_SCREEN_JIRA_ATTACHMENT"] = "project.screen.jira_attachment";
  NotificationTypeEnum["WORKSPACE_ORGANIZATION_MEMBER"] = "workspace.organization.member";
  NotificationTypeEnum["PROJECT_SLACK_INTEGRATION"] = "project.slack_integration";
  NotificationTypeEnum["STYLEGUIDE_SLACK_INTEGRATION"] = "styleguide.slack_integration";
  NotificationTypeEnum["PROJECT_MEMBER"] = "project.member";
  NotificationTypeEnum["STYLEGUIDE_MEMBER"] = "styleguide.member";
  NotificationTypeEnum["PROJECT_FLOW_BOARD"] = "project.flow_board";
})(NotificationTypeEnum || (exports.NotificationTypeEnum = NotificationTypeEnum = {}));